import React, { Fragment } from "react";
import { Container } from "../../components";

import { lazyWithRetry } from "../../core/lazy_with_retry";
import { FAQ } from "../template_offering_details_base";
import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { Text } from "../text";
import { useLuminaryAnalytics } from "./luminary_analytics";
import {
  dayOfficeFaqs,
  generalInfo,
  partnerConfig,
  testimonials,
} from "./luminary_partner_config";

const Theme = lazyWithRetry(() => import("./luminary_theme"));
export const faqs: FAQ[] = [
  {
    question: "What are Luminary's hours?",
    answer: (
      <Container>
        <Text>Luminary’s current hours are: </Text>
        <Text>Monday through Thursday from 8:30am-7pm</Text>
        <Text>Fridays from 8:30am-6pm</Text>
        <Text>Saturdays from 10am-4pm</Text>
      </Container>
    ),
  },
];
export function OfferingLuminaryDayOffice() {
  useLuminaryAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress={false}
        capacityOptionLabel=""
        showDirections
        partnerConfig={partnerConfig}
        data={{
          testimonials: testimonials,
          faqs: faqs.concat(dayOfficeFaqs),
          generalInfo,
        }}
      />
    </Fragment>
  );
}
